import React from "react"
import JsonStepsModal from "./content/JsonStepsModal"

export default function ModalReviews({pro})
{            
    const endpoint = 'https://bookable-apollo-dev.azurewebsites.net/api/v1/review-form'

    let hardcodedData = 
    {
        id: pro.profile.id,
        pro_name: pro.profile.name
    }

    return (
        <JsonStepsModal 
            endpoint = {endpoint} 
            startOpened = {false} 
            title = {pro.name} 
            slug = {'reviews-modal'} 
            confirmClose = {false} 
            backdropClose = {false}
            hardcodedData = {hardcodedData} />
    ) 
}